import { Box, Button, Icon, Typography, Callout } from '@vp/swan';
import React, { useContext } from 'react';
import './src-components-ChatWindow-ChatHeader-ChatHeader.styles.scss.js';
import { CAContext } from './src-contexts-CAContext.js';
import { isStudioPage } from './src-utils-chat-page-utils.js';
import { useCustomChatEvents } from './src-hooks-custom-hooks-useCustomChatEvents.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';

const ChatHeader = ({ onChatClose, onChatMinimize }) => {
  const {
    chatState: { enableChatbot, chatHeaderText, chatSession, chatWindowHandler, chatButtonHandler },
    setChatState
  } = useContext(CAContext);
  const { sendChatEvents } = useCustomChatEvents();
  const { logCustomAttributesNR } = useNRLogging();
  const onBackButtonClick = () => {
    logCustomAttributesNR("ca-chatbot-info", {
      logName: "back_button_clicked",
      logLevel: "info",
      message: "User clicked on back button from chat window"
    });
    chatWindowHandler("hide");
    chatButtonHandler("hide");
    setChatState((prevState) => ({
      ...prevState,
      chatWindow: "hidden"
    }));
    sendChatEvents("onBackButtonClicked", {});
  };
  return /* @__PURE__ */ React.createElement(Box, { className: `chatWindowHeader`, compactMode: true, id: "chatWindowHeader" }, /* @__PURE__ */ React.createElement(Box, { className: "chatMenu" }, isStudioPage() && /* @__PURE__ */ React.createElement(Button, { skin: "tertiary", onClick: onBackButtonClick, p: 4 }, /* @__PURE__ */ React.createElement(Icon, { iconType: "arrowLeft", size: "standard" })), /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-standard-bold" }, chatHeaderText), enableChatbot && chatSession !== "miawChatSession" && /* @__PURE__ */ React.createElement(Callout, { className: "callout" }, "Beta")), /* @__PURE__ */ React.createElement(Box, { className: "chatControls" }, /* @__PURE__ */ React.createElement(Button, { skin: "tertiary", onClick: onChatMinimize, p: 4 }, /* @__PURE__ */ React.createElement(Icon, { iconType: "minus", size: "standard" })), /* @__PURE__ */ React.createElement(Button, { skin: "tertiary", onClick: onChatClose, p: 4 }, /* @__PURE__ */ React.createElement(Icon, { iconType: "close", size: "standard" }))));
};

export { ChatHeader as default };
//# sourceMappingURL=src-components-ChatWindow-ChatHeader-ChatHeader.js.map
